var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "13",
        height: "18",
        viewBox: "0 0 13 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0 2.625C0 1.45293 0.95293 0.5 2.125 0.5H7.4375V4.75C7.4375 5.3377 7.9123 5.8125 8.5 5.8125H12.75V15.375C12.75 16.5471 11.7971 17.5 10.625 17.5H2.125C0.95293 17.5 0 16.5471 0 15.375V2.625ZM12.75 4.75H8.5V0.5L12.75 4.75Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }